import React, { useEffect, useRef, useState } from "react";
import "./WorkFlowIndex.css";
import { Button, ActionMenu, GenericTable, tCell, DetailCard } from "../utils";
import theme, { buttonClasses } from "../utils/theme";
import { useOrgs, useUserDetail, useWorkflow, usePlant, useUserPermissions } from "../../services/hooks";
import Genericfilter from "../utils/Genericfilter";
import { debounce, isObjectEqual } from "../../services/functions";
import { Grid } from "@mui/material";
import { GenericstatsV2 } from "../utils/Genericstats";
import { Link, Navigate, useLocation, useNavigate } from "react-router-dom";
import { usePlantContext } from "../../context/plantContext";
import { Data } from "@react-google-maps/api";
const defaultFilter = {
	pagesize: 10,
	page_no: 1,
};
export default function WorkFlowIndex() {
	const navigate = useNavigate();
	const location = useLocation();
	const { isSuperAdmin } = useUserDetail();
	const { orgOptions } = useOrgs({}, { skip: !isSuperAdmin });
	const filterData = location.state?.filterData;
	const filterRef = useRef(defaultFilter);
	if (filterData) filterRef.current = { ...filterRef.current, ...filterData };
	const { page_no, pagesize } = filterRef.current;
	const { workflowListing, error: workflowError, isLoading: isUpdating, getWorkflow, count } = useWorkflow(filterRef.current);
	
	const { plantId } = usePlantContext();
	const { userPermissions, isFetched } = useUserPermissions();
	const shouldHandlePlant = isSuperAdmin || userPermissions?.managePlant?.value;
	const { plantOptions, getPlantDetails, clearPlants } = usePlant();
	const [detail, setDetail] = useState(null);
	const [isOpen, setIsOpen] = useState(false);
	if (!isSuperAdmin) {
		filterRef.current.plantIds = plantId;
	}
	const filterFields = [
		{
			inputType: "textfield",
			id: "1",
			name: "name",
			type: "text",
			label: "Display Name",
			placeholder: "Display Name",
			readOnly: false,
			error: "",
			value: filterRef.current?.name || "",
		},
	];
	// Using this useEffect to resolve the issue of page refresh state.
	// The problem was: when we refreshed the page and currentFilters existed, the filters were not being cleared.
	useEffect(() => {
		navigate(".", { replace: true });
	}, [navigate]);
	useEffect(() => {
		if (filterData?.orgId && isSuperAdmin) {
			getPlantDetails({ orgId: filterData.orgId });
		}
	}, [filterData]);
	useEffect(() => {
		if (filterRef.current && !isSuperAdmin) {
			getWorkflow(filterRef.current);
		}
	}, [plantId]);

	const handleDetailClose = () => {
		setIsOpen(false);
	};
	const handleWorkflowView = (e, index) => {
		setDetail( createWorkFlowDetailData(workflowListing[index == undefined ? e : index]));
		setIsOpen(true);
	};
	const createWorkFlowDetailData=(dataToShow)=>{
		const result= (
			<>
				<div style={{display:"flex", justifyContent:"center", alignItems:"center", marginBottom:"8px", fontWeight:"bold"}}>Workflow Name: {dataToShow?.name}</div>
				{dataToShow?.checkpoints?.map((key, i) => {
					return(
							<div className="dashboard-status-card" key={i}>
								<div className="dashboard-status-card-uppper">
										<div className="dashboard-status-card-uppper-left">
											<div className="dot" style={{color:"#fff"}}>
												{/* <CheckIcon fontSize={"10px"} htmlColor={"#fff"} /> */}
											<div style={{fontSize: "10px"}}>{key?.order}</div>	
											</div>
											{i <= dataToShow?.checkpoints?.length-2 ? <div className="arrow"></div> : ""}
										</div>
										<div className="dashboard-status-card-uppper-right" style={{paddingBottom:"40px"}}>
											<div className="content-header" style={{display:"flex", flexWrap:"wrap"}}>
													{key?.checkpoints?.map((chk, j)=>{
													return(
														<span style={{padding:"4px 14px", margin:"1px" }} key={j}>
															{chk?.displayName}&nbsp;
														</span>
													)
												})}

											</div>
											<div className="content-detail" style={{marginTop:"2px"}}>
												{key?.optional ? <span>(Optional)</span>:<span></span>}
											</div>
										</div>
								</div>
							</div>
					)

				})}				
			</>
		)
		return result
	}
	if (isSuperAdmin) {
		filterFields.push({
			inputType: "dropdown",
			id: "orgId",
			name: "orgId",
			label: "Organization",
			error: "",
			option: orgOptions,
			value: filterRef.current?.orgId || "",
		});
	}
	if (isSuperAdmin) {
		filterFields.push({
			inputType: "dropdown",
			id: "plantIds",
			name: "plantIds",
			label: "Warehouse",
			error: "",
			option: plantOptions,
			value: filterRef.current?.plantIds || "",
		});
	}
	let actionHandlers = {};
	if (isSuperAdmin || userPermissions?.updateWorkflow?.value) {
		actionHandlers.edit = (id) => {
			if (workflowListing?.length > 0) {
				navigate("/edit-workflow", { state: { data: workflowListing[id], filterData: filterRef.current } });
			}
		};
	}
	if (isSuperAdmin || userPermissions?.addWorkflow?.value) {
		actionHandlers.duplicate = (id) => {
			if (workflowListing?.length > 0) {
				navigate("/add-workflow", { state: { data: workflowListing[id], filterData: filterRef.current } });
			}
		};
	}

	let header = ["S.no", "Display Name"];
	if (isSuperAdmin) {
		header.push("Org Name");
	}
	if (userPermissions?.updateWorkflow?.value || userPermissions?.addWorkflow?.value || isSuperAdmin) {
		header.push("Action");
	}
	const rows =
		workflowListing?.map((d, i) => {
			let row = [];
			row.push(tCell((page_no - 1) * pagesize + i + 1));
			row.push(tCell(d.name, theme.themeOrange, "pointer", handleWorkflowView, i, "name"));
			if (isSuperAdmin) {
				row.push(tCell(d.orgName));
			}
			if (userPermissions?.updateWorkflow?.value || userPermissions?.addWorkflow?.value || isSuperAdmin) {
				row.push(
					<div style={{ paddingLeft: "0.5rem" }}>
						<ActionMenu id={i} handlers={actionHandlers} />
					</div>
				);
			}
			return row;
		}) || [];

	const onPageChange = (page_no) => {
		filterRef.current = { ...filterRef.current, page_no: page_no + 1 };
		getWorkflow(filterRef.current);
	};
	const onPageSizeChange = (e) => {
		const { value } = e.target;
		filterRef.current = { ...filterRef.current, pagesize: value };
		getWorkflow(filterRef.current);
	};

	const handleFilterChange = (_filter) => {
		let filter = { ..._filter };
		for (let key in filter) {
			if (!filter[key]) delete filter[key];
		}
		if (isSuperAdmin) {
			if (filter.orgId) {
				// filter.orgId = filter.orgId?.value;
				if (shouldHandlePlant && filter.orgId != filterRef.current.orgId) {
					// when switching organization, we want to
					// - get plants for that org
					// - clear plantIds from the local filter object
					// - clear plantIds from original filter object, mutating the state and clearing the plant dropdown
					delete filter.plantIds;
					delete _filter.plantIds;
					getPlantDetails({ orgId: filter.orgId });
				}
			} else {
				delete filter.plantIds;
				clearPlants();
			}
		}
		filter.page_no = 1;
		filter.pagesize = 10;
		if (plantId) {
			filter.plantIds = plantId;
		}
		if (!isObjectEqual(filterRef.current, filter)) {
			filterRef.current = { ...filter };
			getWorkflow(filterRef.current);
		}
	};
	const handleAddWorkflow = () => {
		navigate("/add-workflow", { state: { filterData: filterRef.current } });
	};
	if (isFetched && userPermissions && Object.keys(userPermissions).length && !userPermissions?.getWorkflow?.value) return <Navigate to="/not-authorized" replace />;
	return (
		<>
			<div className="Workflow_panel">
				<Grid container spacing="1rem">
					<Grid item xl={11} lg={10} md={10} sm={9} xs={6}>
						<div className="workflow_heading">Workflow</div>
					</Grid>
					{isSuperAdmin || userPermissions?.addWorkflow?.value ? (
						<Grid item xl={1} lg={2} md={2} sm={3} xs={6} display={"flex"} justifyContent={"flex-end"}>
							<div>
								<Button text="Add Workflow" style={{ ...buttonClasses.lynkitOrangeEmpty, width: "fit-content" }} onClick={handleAddWorkflow} />
							</div>
						</Grid>
					) : null}
				</Grid>
			</div>
			<>
				<GenericstatsV2 statsFor={"workflow"} plantId={plantId} />
				<div className="cust-row flex-algn-cent">
					<Genericfilter filterFields={filterFields} onFilterChange={debounce((filter) => handleFilterChange(filter), 500)} addOnClear />
				</div>
				<div style={{display:"flex"}}>
					<GenericTable
						header={header}
						rows={rows}
						pageCount={count}
						pageNo={filterRef.current.page_no}
						limit={filterRef.current.pagesize}
						onPageChange={onPageChange}
						onPageSizeChange={onPageSizeChange}
						isLoading={isUpdating}
					/>
					<div id="cpdetails">
						<DetailCard isOpen={isOpen} onClose={handleDetailClose} title={"Detail"}>
							{detail}
						</DetailCard>
					</div>
				</div>
			</>
		</>
	);
}
